/* ===== Joy — ecranul final „Pagina ta e gata!” =====
 * Confetti + 3 acțiuni: Vezi pagina · Descarcă QR · Trimite pe WhatsApp.
 * Dacă nu există link public, propune unul din numele localului.
 */
import { getCurrentSettings, loadSettings } from '../services/settings.js?v=82.86';
import { getCurrentUser } from '../services/auth.js?v=82.86';
import { saveCampaignSettingsBackend } from '../services/backend.js?v=82.86';
import { showSnackbar } from '../utils/ui.js?v=82.86';

function el(tag, attrs = {}, ...children) {
  const n = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs || {})) {
    if (v == null || v === false) continue;
    if (k === 'class') n.className = v;
    else if (k === 'text') n.textContent = v;
    else if (k.startsWith('on') && typeof v === 'function') n.addEventListener(k.slice(2), v);
    else if (k === 'value') n.value = v;
    else n.setAttribute(k, v === true ? '' : String(v));
  }
  for (const c of children.flat()) {
    if (c == null || c === false) continue;
    n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
  }
  return n;
}

function slugFrom(name) {
  return String(name || '')
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')
    .slice(0, 40);
}

function pageUrl(slug) {
  return `${window.location.origin}/m/${encodeURIComponent(slug)}`;
}

function confetti(host) {
  if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
  const c = document.createElement('canvas');
  c.className = 'joyc-confetti';
  host.appendChild(c);
  const ctx = c.getContext('2d');
  const W = (c.width = window.innerWidth);
  const H = (c.height = window.innerHeight);
  const colors = ['#a78bfa', '#4ade80', '#facc15', '#f472b6', '#60a5fa'];
  const parts = Array.from({ length: 140 }, () => ({
    x: W / 2 + (Math.random() - 0.5) * 120,
    y: H * 0.35,
    vx: (Math.random() - 0.5) * 12,
    vy: -Math.random() * 12 - 4,
    s: 4 + Math.random() * 5,
    r: Math.random() * Math.PI,
    vr: (Math.random() - 0.5) * 0.3,
    c: colors[Math.floor(Math.random() * colors.length)]
  }));
  let frames = 0;
  const tick = () => {
    frames += 1;
    ctx.clearRect(0, 0, W, H);
    for (const p of parts) {
      p.vy += 0.28;
      p.x += p.vx;
      p.y += p.vy;
      p.r += p.vr;
      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.r);
      ctx.fillStyle = p.c;
      ctx.fillRect(-p.s / 2, -p.s / 2, p.s, p.s * 0.6);
      ctx.restore();
    }
    if (frames < 170) requestAnimationFrame(tick);
    else c.remove();
  };
  requestAnimationFrame(tick);
}

async function downloadQr(slug, name) {
  const QR = await import('https://cdn.jsdelivr.net/npm/qrcode@1.5.3/+esm');
  const dataUrl = await QR.toDataURL(pageUrl(slug), { width: 1024, margin: 2, errorCorrectionLevel: 'M' });
  const a = document.createElement('a');
  a.href = dataUrl;
  a.download = `qr-${slugFrom(name) || slug}.png`;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

/**
 * Afișează ecranul final. onView() deschide vizualizarea clientului.
 */
export function showJoyCelebration({ onView }) {
  const s = getCurrentSettings() || {};
  const name = s.locationMapName || s.companyName || 'Localul tău';
  let slug = String(s.publicSlug || '').trim();

  const overlay = el('div', { class: 'joyc-overlay', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Pagina ta e gata' });
  const card = el('div', { class: 'joyc-card' });
  overlay.appendChild(card);

  const close = () => overlay.remove();

  const render = () => {
    const actions = el('div', { class: 'joyc-actions' });
    if (slug) {
      actions.append(
        el('button', { class: 'joyc-btn joyc-btn--main', type: 'button', onclick: () => { close(); onView?.(); } }, '👀 Vezi pagina'),
        el('button', {
          class: 'joyc-btn', type: 'button',
          onclick: async (e) => {
            const b = e.currentTarget;
            b.disabled = true;
            try { await downloadQr(slug, name); showSnackbar('QR descărcat — printează-l și pune-l pe mese.'); }
            catch (_) { showSnackbar('Nu am putut genera QR-ul. Verifică conexiunea.'); }
            finally { b.disabled = false; }
          }
        }, '⬇️ Descarcă QR-ul'),
        el('a', {
          class: 'joyc-btn joyc-btn--wa', target: '_blank', rel: 'noopener',
          href: `https://wa.me/?text=${encodeURIComponent(`Uite pagina ${name}: ${pageUrl(slug)}`)}`
        }, '💬 Trimite pe WhatsApp')
      );
    } else {
      const inp = el('input', { class: 'joyc-input', value: slugFrom(name), maxlength: 48, 'aria-label': 'Link pagină' });
      const save = el('button', { class: 'joyc-btn joyc-btn--main', type: 'button' }, 'Salvează linkul');
      save.addEventListener('click', async () => {
        save.disabled = true;
        try {
          await saveCampaignSettingsBackend({ publicSlug: inp.value.trim().toLowerCase() });
          const uid = getCurrentUser()?.uid;
          if (uid) await loadSettings(uid, true);
          slug = String(getCurrentSettings()?.publicSlug || inp.value.trim().toLowerCase());
          render();
        } catch (e) {
          showSnackbar(e?.message || 'Nu am putut salva linkul.');
          save.disabled = false;
        }
      });
      actions.append(
        el('p', { class: 'joyc-sub', text: 'Alege linkul paginii tale:' }),
        el('div', { class: 'joyc-slug' }, el('span', { text: `${window.location.host}/m/` }), inp),
        save,
        el('button', { class: 'joyc-link', type: 'button', onclick: () => { close(); onView?.(); } }, 'Mai târziu')
      );
    }
    card.replaceChildren(
      el('div', { class: 'joyc-emoji', text: '🎉' }),
      el('h2', { class: 'joyc-title', text: 'Pagina ta e gata!' }),
      el('p', { class: 'joyc-sub', text: slug ? pageUrl(slug).replace(/^https?:\/\//, '') : name }),
      actions
    );
  };

  render();
  document.body.appendChild(overlay);
  confetti(overlay);
}
